import { apolloCubeClient } from "../../helpers/studyPlan/studyPlanApolloStatic"
import {
  GetLicensedInformationInput
} from "../../../../types/gqlTypes/graphql"
import {
  GET_LICENSED_INFORMATION
} from "./LicensingQueries"

export async function getLicensedInformation(input: GetLicensedInformationInput) {
  const { data } = await apolloCubeClient.query({
    query: GET_LICENSED_INFORMATION,
    variables: { data: {} },
    fetchPolicy: "network-only"
  })
  return data?.licensePools?.getLicensedInformation ?? { }
}
